var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import classnames from 'classnames';
import Depot from '../../_shared/depot';
import * as styles from './style.module.css';
import colors from '../shared/colors';
const Heading = (_a) => {
    var { typeStyle = 'title2', as = 'h2', color = 'base', children } = _a, commonProps = __rest(_a, ["typeStyle", "as", "color", "children"]);
    return Depot.createElement(as, Object.assign(Object.assign({}, commonProps), { className: classnames(styles.root, styles[typeStyle], colors[color]) }), children);
};
export default Heading;
//# sourceMappingURL=index.js.map